<template>
<div>
    <div class="app-body">
        <page-header></page-header>
        <div class="allContain xy-between">
            <nav-bar></nav-bar>
            <div class="accountSet">
                <div class="tit font-size16 jf">
                    <div class="btns yx-between" @click="TabQuestion">
                        <div>试题</div>
                        <div :class="{'tab' :navigationActive === 'question' }"></div>
                    </div>

                    <div class="btns yx-between" @click="TabPaper">
                        <div>试卷</div>
                        <div :class="{'tab' :navigationActive === 'paper' }"></div>
                    </div>
                </div>
                <div>

                    <!--试题-->
                    <div v-if="navigationActive === 'question'" class="information">
                        <collectQuestion></collectQuestion>
                    </div>
                    <!--试题-->

                    <!--试卷-->
                    <div v-if="navigationActive === 'paper'" class="customTitle">
                        <collectPaper></collectPaper>
                    </div>
                    <!--试卷-->
                </div>
            </div>
        </div>
    </div>
     <bottom-ground></bottom-ground>
     </div>
</template>

<script>
import { accountLogin } from "@/api/user";
import PageHeader from "@/components/header";
import NavBar from "@/components/personCenter/nav";
import collectPaper from "@/components/collect/collectPaper";
import collectQuestion from "@/components/collect/collectQuestion";
import BottomGround from "@/components/bottomnav";
export default {
    components: {
        PageHeader,
        NavBar,
        collectPaper,
        collectQuestion,
        BottomGround
    },
    created() {

    },
    data() {
        return {
            currentNav: "collect",
            navigationActive: "question"
        }
    },
    methods: {
        TabQuestion() {
            this.navigationActive = "question"
        },
        TabPaper() {
            this.navigationActive = "paper"
        }
    }
}

</script>

<style lang="less" scoped>
    .allContain {
        width: 100%;
        margin: 0 auto;
        margin-top: 20px;
        margin-bottom: 30px;
        .accountSet {
            width: 940px;
            height: 830px;
            background-color: white;
            border-radius: 16px;

            .tit {
                padding: 20px 20px 0px 20px;
                box-sizing: border-box;
                border-bottom: 1px solid #E5E8EC;

                .btns {
                    width: 55px;
                    height: 35px;
                    box-sizing: border-box;
                    margin: 0 25px 0 25px;
                    cursor: pointer;

                    .tab {
                        width: 50px;
                        height: 4px;
                        background: #256CF4;
                        border-radius: 2px;
                        
                    }
                }
            }

            .information {
                padding: 20px 30px;
                box-sizing: border-box;

                .line {
                    margin-bottom: 30px;

                    span {
                        font-size: 16px;
                    }

                    .header {
                        width: 120px;
                        padding-right: 30px;
                        text-align: right;
                    }

                    ::v-deep .el-input__inner {
                        width: 350px;
                        height: 40px;
                        font-size: 14px;
                    }
                }

                .saveBtn {
                    width: 70px;
                    height: 35px;
                    margin-left: -18px;
                    background: #256CF4;
                    border-radius: 4px;
                    color: white;

                }

                .fristLine {
                    margin-top: 20px;
                }
            }

            .customTitle {
                padding: 20px 30px;
                box-sizing: border-box;
            }

            .detailBox {
                padding: 20px 30px;
                box-sizing: border-box;
            }
        }
    }

</style>
